// แถบแนวตั้งบอกว่าเราอยู่สูงหรือต่ำกว่าระดับน้ำทะเลเท่าไร
// ใช้สเกลรากที่สอง ระยะใกล้ระดับน้ำทะเล (ที่สัตว์ส่วนใหญ่อยู่) จึงมีที่บนแถบมากกว่ายอดเขาและร่องลึกก้นสมุทร

import type { Altitude } from "../../geo/place";

const TOP = 6000; // เมตร เหนือระดับน้ำทะเล
const BOTTOM = -11000; // ใกล้ร่องลึกมาเรียนา
const H = 220;
const COL_X = 38;
const COL_W = 30;

const s = (m: number) => Math.sign(m) * Math.sqrt(Math.abs(m));
const y = (m: number) => ((s(TOP) - s(Math.max(BOTTOM, Math.min(TOP, m)))) / (s(TOP) - s(BOTTOM))) * H;

const TICKS: [number, string][] = [
  [5000, "+5 กม."],
  [1000, "+1 กม."],
  [0, "0"],
  [-200, "−200 ม."],
  [-1000, "−1 กม."],
  [-4000, "−4 กม."],
  [-10000, "−10 กม."],
];

export function AltitudeBar({ altitude }: { altitude: Altitude }) {
  const sea = y(0);
  const ground = y(altitude.ground);
  const me = y(altitude.altitude);
  const label = altitude.onSea ? "แถบความลึกจากผิวน้ำ" : "แถบความสูงจากระดับน้ำทะเล";

  return (
    <svg className="altitude" viewBox={`0 0 72 ${H}`} role="img" aria-label={label}>
      <defs>
        <linearGradient id="alt-water" x1="0" x2="0" y1="0" y2="1">
          <stop offset="0" className="alt-water-top" />
          <stop offset="1" className="alt-water-deep" />
        </linearGradient>
      </defs>
      <rect className="alt-sky" x={COL_X} y={0} width={COL_W} height={altitude.onSea ? sea : ground} rx={4} />
      {altitude.onSea && <rect x={COL_X} y={sea} width={COL_W} height={Math.max(0, ground - sea)} fill="url(#alt-water)" />}
      <rect className="alt-earth" x={COL_X} y={ground} width={COL_W} height={H - ground} />
      <line className="alt-sea-level" x1={COL_X - 3} x2={COL_X + COL_W} y1={sea} y2={sea} />
      {TICKS.map(([m, text]) => (
        <g key={m} className="alt-tick">
          <line x1={COL_X - 3} x2={COL_X} y1={y(m)} y2={y(m)} />
          <text x={COL_X - 5} y={y(m) + 3} textAnchor="end">
            {text}
          </text>
        </g>
      ))}
      <g className="alt-me" transform={`translate(${COL_X + COL_W / 2} ${Math.min(H - 5, Math.max(5, me))})`}>
        <circle className="pulse" r={7} />
        <circle r={4} />
      </g>
    </svg>
  );
}
